import { Box, Stack } from "@mui/material";
import { TypeButton } from "../../../../components/type-button";
import { H6Typography } from "../../../../components/typography";
import { ReactComponent as MoodBoardIcon } from "../../../../assets/designer-files/Design Board Icon Mood.svg";
import { ReactComponent as ColorBoardIcon } from "../../../../assets/designer-files/Design Board Icon Color.svg";
import { ReactComponent as PatternBoardIcon } from "../../../../assets/designer-files/Design Board Icon Pattern.svg";
import { ReactComponent as StyleFusionBoardIcon } from "../../../../assets/designer-files/Design Board Icon Style Fusion.svg";
import { ReactComponent as TextureBoardIcon } from "../../../../assets/designer-files/Design Board Icon Texture.svg";
import { DesignBoardType } from "../../../../__generated__/types";
import { DesignBoardTypeLabels } from "../../../../utils";
import { RadioCircle } from "../../../../components/radio-circle";

const DesignBoardTypeButton = ({
  type,
  onClick,
  selected = false,
  disabled = false,
}: {
  type: DesignBoardType;
  onClick: (type: DesignBoardType) => void;
  selected?: boolean;
  disabled?: boolean;
}) => {
  const iconLookup: Record<DesignBoardType, JSX.Element> = {
    [DesignBoardType.Mood]: <MoodBoardIcon width={48} height={48} />,
    [DesignBoardType.Color]: <ColorBoardIcon width={48} height={48} />,
    [DesignBoardType.TextureAndFinish]: <TextureBoardIcon width={48} height={48} />,
    [DesignBoardType.PatternPlay]: <PatternBoardIcon width={48} height={48} />,
    [DesignBoardType.StyleFusion]: <StyleFusionBoardIcon width={48} height={48} />,
  };

  return (
    <TypeButton
      icon={iconLookup[type]}
      onClick={() => onClick(type)}
      sx={{
        position: "relative",
        borderColor: selected ? "#00a06d" : "",
      }}
      disabled={disabled}
    >
      <RadioCircle
        sx={{
          position: "absolute",
          top: "16px",
          right: "16px",
          left: "auto",
          zIndex: 1,
        }}
        size={24}
        color={"#00a06d"}
        checked={selected}
      />
      <H6Typography component="p" mt="16px">
        {DesignBoardTypeLabels[type]}
      </H6Typography>
    </TypeButton>
  );
};

export const DesignBoardTypeSelection = ({
  onSelect,
  value,
  lockedType,
}: {
  onSelect: (type: DesignBoardType) => void;
  value?: DesignBoardType;
  lockedType?: DesignBoardType;
}) => {
  return (
    <Box>
      <H6Typography>Select a board type to continue</H6Typography>
      <Stack
        direction={{
          xs: "column",
          md: "row",
        }}
        spacing={2}
        mt="16px"
        justifyContent={"space-between"}
      >
        {Object.values(DesignBoardType).map((type) => (
          <DesignBoardTypeButton
            key={type}
            selected={value === type}
            type={type}
            onClick={(nextType) => {
              if (lockedType && nextType !== lockedType) {
                return;
              }
              onSelect(nextType);
            }}
            disabled={Boolean(lockedType && type !== lockedType)}
          />
        ))}
      </Stack>
    </Box>
  );
};
